import { Component, OnInit, Injectable } from '@angular/core';
import { UserModel } from '../../shared/model/userModel';
import { ResetAccountService } from './services/resetAccount.service';
import { AbstractResetAccountService } from './services/abstract-resetAcountService';
import { Router } from '@angular/router';
import { AbstractSessionService } from '../../session/abstract-session.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../appState/appStateStore.module';
import { ErrorAction } from '../../appState/app.actions';
import { ERROR_USER_DELETED, ERROR_USER_IN_REGISTRATION } from '../../error/errorMessage';

@Component({
  selector: 'app-resetAccount',
  templateUrl: './resetAccount.component.html',
  styleUrls: ['./resetAccount.component.css']
})
export class ResetAccountComponent implements OnInit {
  model: UserModel = new UserModel();
  loading: boolean = false;
  error: string = null;
  passwordRepeat: string = '';
  message: string = null;
  questionText = '';
  hide = true;
  hide2 = true;

  constructor(private resetAccountService: AbstractResetAccountService, private router: Router,
              private sessionService: AbstractSessionService, private store: Store<AppState>) { }

  ngOnInit() {
    this.getQuestion();
   }

  resetUser() {
    this.loading = true;
    this.resetAccountService.resetAccount(this.model)
        .subscribe(
          (success) => {
            this.message = 'Der Benutzer wurde erfolgreich zurückgesetzt';
            //console.log('User zurückgesetzt.')
          },
          (err) => {
            this.showError(err);
          },
          () => {
            this.loading = false;
          }
        );
    }

  onNewPasswordChange(elementToFocus) {
    this.passwordRepeat = '';
    elementToFocus.focus();
  }

  clearError() {
    this.error = null;
    this.getQuestion();
  }

  navigateLogin() {
    this.router.navigate(['login']);
  }

  showError(err:any) {
    if (err && err.status===401) {
      if (err.statusText) {
        if (err.statusText.indexOf('Benutzer wurde gelöscht') >= 0) {
          this.store.dispatch(new ErrorAction(ERROR_USER_DELETED));
          this.router.navigate(['/error']);
        } else if (err.statusText.indexOf('Registrierungsprozess') >= 0) {
          this.store.dispatch(new ErrorAction(ERROR_USER_IN_REGISTRATION));
          this.router.navigate(['/error']);
        }
    else {
          this.error = err.statusText
        }
      } else {
        this.error = 'Keine Berechtigung zum Zur&uuml;cksetzen!'
      }
    } else {
      this.error = 'Fehler beim Zur&uuml;cksetzen!'
    }
  }

  getQuestion() {
    this.questionText = '';
    this.model.questionAnswer = '';
    this.model.questionToken = '';

    this.sessionService.getQuestion('Reset').subscribe(q => {
      this.questionText = q.QuestionText;
      this.model.questionToken = q.Token;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/account/resetAccount/resetAccount.component.ts